module.exports = __webpack_public_path__ + "static/img/v11.f4c0119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v11.jpg
// module id = 3dVn
// module chunks = 1